angular
  .module('ui-ng-calendar-time')
  .constant('CalendarWeekTimeDTD', {
    day_of_week: {
      required: true,
      type: 'ordinal',
      typeDef: 'DayOfTheWeekEnum',
      defaultValue: '',
      writeToKey: 'day'
    },
    from_tm: {
      required: true,
      type: 'clock',
      writeToKey: 'from'
    },
    to_tm: {
      required: true,
      type: 'clock',
      writeToKey: 'to'
    },
    id: 'key',
    trackingId: 'auto-id',
    beginMinutes: 'integer',
    endMinutes: 'integer',
    bkgColorClass: 'string',
    content: 'string',
    appId: '*'
  })
  .factory('CalendarWeekTimeBuilder', function CalendarWeekTimeBuilder(Interface, CalendarWeekTimeDTD) {
    return function CalendarWeekTimeBuilderDTO(o) {
      Interface.implement(CalendarWeekTimeDTD, o, this);

      this.fromMinutes = this.from.hour() * 60 + this.from.minute();
      this.toMinutes = this.to.hour() * 60 + this.to.minute();

      this.fromInput = this.from.toDate();
      this.toInput = this.to.toDate();
    };
  });



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-calendar-time/src/builders/calendar_week_time_builder.js